// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"e37bd5f1","787":"c478a1e6"}[chunkId] + ".chunk.js";
};